import React from "react";

const HiddenInput = ({fieldname,fieldvalue,fieldid, handler, register}) =>{
    return(<input id={fieldid} type="hidden" value={fieldvalue ?? ""}  data-guid={fieldid} onChange={handler} {...register(fieldname)}/>);
}

export default HiddenInput;
